/* eslint-disable jsx-a11y/anchor-is-valid,no-script-url */
import * as React from "react";
import { TabNames } from "./props";
import { AppPermissions, useHasPermission } from "../../../core";
import { RequirementStatus } from "../../../core/api/models/requirement";

export interface CustomProps {
  tabName: TabNames;
  tabChangeHandler: (tabName: TabNames) => void;
  status: RequirementStatus;
  showVersion?: boolean;
  showPropertyTab?: boolean;
}

const Tabs: React.FunctionComponent<CustomProps> = (props) => {
  const [tabName, setTabName] = React.useState<TabNames>(
    props.tabName || TabNames.RequirementDetails
  );
  const setElementActive = (tabValue: TabNames) => {
    setTabName(tabValue);
    props.tabChangeHandler(tabValue);
  };

  return (
    <ul
      className="nav tab-underline mb-3 border-bottom font-sm font-weight-semibold flex-nowrap text-nowrap overflow-auto px-md-0 px-3 w-100"
      id="activity-tab"
      role="tablist"
    >
      <li className="nav-item pr-4" role="presentation">
        <a
          className={`cursor-pointer nav-link position-relative px-0 py-2  ${
            tabName === TabNames.RequirementDetails ? "active" : "text-gray-600"
          }`}
          onClick={(e) => setElementActive(TabNames.RequirementDetails)}
        >
          <span className=" py-1 d-inline-flex">Requirement Details</span>
        </a>
      </li>
      {props.showPropertyTab && (
        <li className="nav-item pr-4" role="presentation">
          <a
            className={`cursor-pointer nav-link position-relative px-0 py-2  ${
              tabName === TabNames.Properties ? "active" : "text-gray-600"
            }`}
            onClick={(e) => setElementActive(TabNames.Properties)}
          >
            <span className=" py-1 d-inline-flex">Properties</span>
          </a>
        </li>
      )}
      {/* <li className="nav-item pr-4" role="presentation">
        <a
          className={`cursor-pointer nav-link position-relative px-0 py-2  ${
            tabName === TabNames.Timeline ? "active" : "text-gray-600"
          }`}
          onClick={(e) => setElementActive(TabNames.Timeline)}
        >
          <span className=" py-1 d-inline-flex">Timeline </span>
        </a>
      </li> */}

      {props.showVersion && (
        <li className="nav-item pr-4" role="presentation">
          <a
            className={`cursor-pointer nav-link position-relative px-0 py-2  ${
              tabName === TabNames.Versions ? "active" : "text-gray-600"
            }`}
            onClick={(e) => setElementActive(TabNames.Versions)}
          >
            <span className=" py-1 d-inline-flex">Requirement Versions </span>
          </a>
        </li>
      )}
      <li className="nav-item pr-4" role="presentation">
        <a
          className={`cursor-pointer nav-link position-relative px-0 py-2  ${
            tabName === TabNames.ConnectedProposal ? "active" : "text-gray-600"
          }`}
          onClick={(e) => setElementActive(TabNames.ConnectedProposal)}
        >
          <span className=" py-1 d-inline-flex">Connected Proposal </span>
        </a>
      </li>
      {/* {props.status === RequirementStatus.Approved && (
        <>
          
          <li className="nav-item pr-4" role="presentation">
            <a
              className={`cursor-pointer nav-link position-relative px-0 py-2  ${
                tabName === TabNames.People ? "active" : "text-gray-600"
              }`}
              onClick={(e) => setElementActive(TabNames.People)}
            >
              <span className=" py-1 d-inline-flex">People </span>
            </a>
          </li>
        </>
      )} */}
      {/* <li className="nav-item pr-4" role="presentation">
        <a
          className={`cursor-pointer nav-link position-relative px-0 py-2  ${
            tabName === TabNames.Log ? "active" : "text-gray-600"
          }`}
          onClick={(e) => setElementActive(TabNames.Log)}
        >
          <span className=" py-1 d-inline-flex">Log </span>
        </a>
      </li> */}
    </ul>
  );
};

export default Tabs;
